import { render, staticRenderFns } from "./editPassDialog.vue?vue&type=template&id=51901012&scoped=true"
import script from "./editPassDialog.vue?vue&type=script&lang=js"
export * from "./editPassDialog.vue?vue&type=script&lang=js"
import style0 from "./editPassDialog.vue?vue&type=style&index=0&id=51901012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51901012",
  null
  
)

export default component.exports